/* src/app/ai-sourcing/ai-sourcing-shortlist/ai-sourcing-shortlist.component.scss */
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.archive {
  color: rgba(205, 15, 15, 0.5411764706) !important;
  border-color: rgba(205, 15, 15, 0.5411764706) !important;
}
.more-ai-matched-card {
  border: 1px solid #9CD1FF;
  background:
    linear-gradient(
      90deg,
      rgba(249, 200, 216, 0.9098039216) -1.65%,
      #ffffff 80%);
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.more-ai-matched-card p {
  font-size: 11px;
  font-weight: normal;
  line-height: 1;
  font-style: italic;
  color: #000000;
  margin-bottom: 0;
}
.more-ai-matched-card .btn-get-more-candidate {
  background-color: #F2F2F2;
  color: #969696;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 8px;
  border: 1px solid #969696;
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate:focus {
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate.active {
  background-color: #ffffff;
  color: #C845AB;
  border: 1px solid #C845AB;
}
.more-ai-matched-card .btn-get-more-candidate.disabled {
  background-color: #E0E0E0;
  color: #969696;
  border: none;
}
.empty-card {
  border: 1px solid rgba(46, 147, 161, 0.3019607843);
  background:
    linear-gradient(
      183.08deg,
      rgba(163, 255, 226, 0.45) -58.69%,
      rgba(255, 255, 250, 0.45) 53.16%,
      rgba(255, 245, 134, 0.45) 164.33%);
  padding: 30px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #484b59;
}
.empty-card div {
  width: 60%;
}
.empty-card span.text-center {
  display: flex;
  justify-content: center;
  font-size: 30px;
}
.empty-card p {
  text-align: center;
  line-height: 1.6;
}
.img-config {
  width: 100%;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
  margin-top: 3px;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox]:checked ~ i {
    background-color: #2e93a1;
    border: 1px solid #2e93a1;
    transition: 0.5s;
  }
  .wc-checkbox i {
    width: 100%;
    height: 100%;
    background-color: #fff;
    color: #FFF;
    border: 1px solid #2e93a1;
    border-radius: 2px;
  }
}
.alert-dismissible .btn-close {
  display: none !important;
}
/*# sourceMappingURL=ai-sourcing-shortlist.component-52MBMUCG.css.map */
